/**
 * Map of colors as RGB tuples (r, g, b).
 * Use with kaplay by calling rgb(...COLORS.RED)
 */
export const Colors = {
  RED: [180, 60, 60],
  GREEN: [70, 160, 70],
  BLUE: [70, 100, 170],
  YELLOW: [200, 180, 60],
  CYAN: [60, 170, 170],
  MAGENTA: [170, 70, 150],
  ORANGE: [210, 140, 70],
  PURPLE: [110, 70, 140],
  WHITE: [230, 230, 230],
  BLACK: [20, 20, 20],
  GRAY: [120, 120, 120],
  PINK: [200, 120, 140],
} as const;

export type RGBTuple = Readonly<[number, number, number]>;
export type ColorName = keyof typeof Colors;

/**
 * Array of the keys of the color enum
 */
export const COLORS = Object.keys(Colors) as ColorName[];

/**
 * Helper function that returns all colors except the excluded one.
 *
 * @param excludedColor the color to exclude
 * @returns an array of all colors except the excluded one
 */
export function getAllColorsButOne(excludedColor: ColorName): ColorName[] {
  return COLORS.filter((color) => color !== excludedColor);
}

/**
 * Helper function that returns a random color from the given array.
 *
 * @param colors the colors to return a random one for
 */
export function getRandomColor(colors: ColorName[]) {
  const randomIndex = Math.floor(Math.random() * colors.length);
  return Colors[colors[randomIndex]] as [number, number, number];
}
